import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { homeForRole } from "@/lib/api";

export default function AuthCallback() {
  const { googleExchange } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const user = await googleExchange(sessionId);
        window.history.replaceState(null, "", window.location.pathname);
        const dest = user.role === "STUDENT" && !user.onboardingCompleted ? "/onboarding" : homeForRole(user.role);
        navigate(dest, { replace: true });
      } catch {
        setError("Sign-in failed. Please try again.");
        setTimeout(() => navigate("/login", { replace: true }), 1500);
      }
    })();
  }, [location.hash, googleExchange, navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 text-muted-foreground">
      <Loader2 className="h-6 w-6 animate-spin" />
      <p>{error || "Signing you in…"}</p>
    </div>
  );
}
